import { handleActions } from "redux-actions";
import { ACTIONS } from "./actions";

const initialState: FaqState = {
	modalContent: null,
	loadFaq: {
		success: null,
		error: null,
		loading: false,
	},
};

export default handleActions(
	{
		[`${ACTIONS.LOAD_FAQ_LIST}_PENDING`]: (state) => ({
			...state,
			loadFaq: {
				...state.loadFaq,
				loading: true,
			},
		}),
		[`${ACTIONS.LOAD_FAQ_LIST}_REJECTED`]: (state, action) => ({
			...state,
			loadFaq: { success: null, error: action.payload, loading: false },
		}),
		[`${ACTIONS.LOAD_FAQ_LIST}_FULFILLED`]: (state, action) => ({
			...state,
			loadFaq: { success: action.payload, error: null, loading: false },
		}),
		[ACTIONS.SET_MODAL_CONTENT]: (state, action) => ({
			...state,
			modalContent: action.payload,
		}),
	},
	initialState
);

export interface FaqState {
	loadFaq: any;
	modalContent: any;
}
